class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  async onSubmit(event) {
    if (!window.fetch || !window.FormData) return;

    event.preventDefault();

    const button = this.form.querySelector('button[type="submit"]');
    const originalText = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(this.form)
      });

      if (!response.ok) throw new Error('Cart add failed');

      if (button) button.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('wahoo:cart-added'));
    } catch (error) {
      if (button) button.textContent = 'Try again';
    } finally {
      window.setTimeout(() => {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      }, 1400);
    }
  }
}

customElements.define('product-form', ProductForm);

const menuToggle = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-menu]');
const menuClose = document.querySelector('[data-menu-close]');

function setMenuOpen(isOpen) {
  if (!menu || !menuToggle) return;

  menu.classList.toggle('is-open', isOpen);
  menuToggle.setAttribute('aria-expanded', String(isOpen));
  document.body.classList.toggle('menu-open', isOpen);
}

if (menuToggle && menu) {
  menuToggle.addEventListener('click', () => {
    setMenuOpen(!menu.classList.contains('is-open'));
  });
}

if (menuClose) {
  menuClose.addEventListener('click', () => setMenuOpen(false));
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') setMenuOpen(false);
});

const siteHeader = document.querySelector('[data-site-header]');

function updateHeaderState() {
  if (!siteHeader) return;
  siteHeader.classList.toggle('is-stuck', window.scrollY > 24);
}

updateHeaderState();
window.addEventListener('scroll', updateHeaderState, { passive: true });

function wahooFormatMoney(cents, format) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents, format);
  }

  const value = (Number(cents || 0) / 100).toFixed(2);
  return `$${value}`;
}

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
  const mediaItems = gallery.querySelectorAll('[data-media-id]');

  function showMedia(mediaId) {
    mediaItems.forEach((item) => {
      if (!item.hasAttribute('data-gallery-thumb')) {
        const isActive = item.dataset.mediaId === String(mediaId);
        item.classList.toggle('is-hidden', !isActive);
      }
    });

    thumbs.forEach((thumb) => {
      const isActive = thumb.dataset.mediaId === String(mediaId);
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-pressed', String(isActive));
    });
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId));
  });

  gallery.showMedia = showMedia;
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const productJson = root.querySelector('[data-product-json]');
  const form = root.querySelector('form.product-form');
  if (!productJson || !form) return;

  let product;
  try {
    product = JSON.parse(productJson.textContent);
  } catch (error) {
    return;
  }

  const optionInputs = form.querySelectorAll('[data-product-option]');
  const variantInput = form.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-product-price]');
  const compare = root.querySelector('[data-product-compare]');
  const sale = root.querySelector('[data-product-sale]');
  const inventory = root.querySelector('[data-product-inventory]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const quantityInput = root.querySelector('[data-quantity-input]');
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

  function getSelectedOptions() {
    const selected = [];
    product.options.forEach((optionName) => {
      const checked = form.querySelector(`[name="options[${CSS.escape(optionName)}]"]:checked`);
      const select = form.querySelector(`select[name="options[${CSS.escape(optionName)}]"]`);
      selected.push(checked ? checked.value : select ? select.value : '');
    });
    return selected;
  }

  function findVariant() {
    const selected = getSelectedOptions();
    return product.variants.find((variant) => {
      return variant.options.every((option, index) => option === selected[index]);
    });
  }

  function setInventoryText(variant) {
    if (!inventory) return;

    if (!variant || !variant.available) {
      inventory.textContent = 'Sold out';
      return;
    }

    if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
      inventory.textContent = `Low stock - ${variant.inventory_quantity} left`;
      return;
    }

    inventory.textContent = 'In stock and ready to ship';
  }

  function updateVariant() {
    const variant = findVariant();
    const isAvailable = Boolean(variant && variant.available);

    if (variantInput && variant) variantInput.value = variant.id;
    if (price && variant) price.textContent = wahooFormatMoney(variant.price, moneyFormat);

    if (compare && sale && variant && variant.compare_at_price > variant.price) {
      compare.textContent = wahooFormatMoney(variant.compare_at_price, moneyFormat);
      compare.classList.remove('is-hidden');
      sale.classList.remove('is-hidden');
    } else {
      if (compare) compare.classList.add('is-hidden');
      if (sale) sale.classList.add('is-hidden');
    }

    setInventoryText(variant);

    if (addButton) {
      addButton.disabled = !isAvailable;
      addButton.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
    }

    if (variant && variant.featured_media) {
      const gallery = root.querySelector('[data-product-gallery]');
      if (gallery && typeof gallery.showMedia === 'function') gallery.showMedia(variant.featured_media.id);
    }

    if (variant) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  optionInputs.forEach((input) => {
    input.addEventListener('change', updateVariant);
  });

  root.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!quantityInput) return;

      const current = Number(quantityInput.value || 1);
      const next = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
      quantityInput.value = next;
    });
  });
});

document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
  const url = section.dataset.url;
  const grid = section.querySelector('[data-recommendations-grid]');
  if (!url || !grid || grid.children.length > 0 || !window.fetch) return;

  try {
    const response = await fetch(url);
    if (!response.ok) return;

    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');
    const recommendations = html.querySelector('[data-recommendations-grid]');
    if (recommendations && recommendations.children.length > 0) {
      grid.innerHTML = recommendations.innerHTML;
    }
  } catch (error) {
    return;
  }
});

function initInstagramSlider(section) {
  const slider = section.querySelector('[data-instagram-slider]');
  if (!slider || slider.dataset.sliderReady === 'true') return;

  slider.dataset.sliderReady = 'true';

  const prev = section.querySelector('[data-instagram-prev]');
  const next = section.querySelector('[data-instagram-next]');
  const dotsWrap = section.querySelector('[data-instagram-dots]');
  const dotTemplate = section.querySelector('[data-instagram-dot-template]');
  const status = section.querySelector('[data-instagram-status]');
  const feedUrl = section.dataset.instagramFeedUrl;
  const dynamicLimit = Number(section.dataset.instagramLimit || 8);

  let slides = Array.from(slider.querySelectorAll('.instagram-slide'));
  let dots = Array.from(section.querySelectorAll('[data-instagram-dot]'));

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  function normalizeItems(payload) {
    const source = Array.isArray(payload) ? payload : payload && (payload.items || payload.data || payload.media);
    if (!Array.isArray(source)) return [];

    return source.map((item) => {
      const permalink = item.permalink || item.link || item.url;
      const caption = item.caption || item.title || '';
      const mediaType = item.media_type || item.mediaType || '';
      const thumbnailUrl = item.thumbnail_url || item.thumbnailUrl;
      const mediaUrl = item.media_url || item.mediaUrl;
      const imageUrl = item.image_url || item.imageUrl || (String(mediaType).toUpperCase() === 'VIDEO' ? thumbnailUrl || mediaUrl : mediaUrl || thumbnailUrl);

      return {
        imageUrl,
        permalink,
        caption,
        mediaType,
        altText: item.alt_text || item.altText || caption || 'WaHoo Instagram post'
      };
    }).filter((item) => isSafeUrl(item.imageUrl));
  }

  function isSafeUrl(value) {
    if (!value) return false;

    try {
      const url = new URL(value, window.location.origin);
      return url.protocol === 'https:' || url.protocol === 'http:';
    } catch (error) {
      return false;
    }
  }

  function createSlide(item) {
    const article = document.createElement('article');
    article.className = 'instagram-slide';

    const safePermalink = item.permalink && isSafeUrl(item.permalink) ? item.permalink : '';
    const tagName = safePermalink ? 'a' : 'div';
    const tile = document.createElement(tagName);
    tile.className = 'instagram-tile';
    tile.setAttribute('aria-label', item.caption || item.altText || 'View Instagram post');

    if (safePermalink) tile.href = safePermalink;
    if (!safePermalink) tile.setAttribute('role', 'img');

    tile.innerHTML = `
      <img
        class="instagram-tile__image"
        src="${escapeHtml(item.imageUrl)}"
        alt="${escapeHtml(item.altText)}"
        loading="lazy"
      >
      <span class="instagram-tile__overlay">
        <span class="instagram-tile__icon" aria-hidden="true">ig</span>
        ${item.caption ? `<span class="instagram-tile__caption">${escapeHtml(item.caption)}</span>` : ''}
      </span>
    `;

    article.appendChild(tile);
    return article;
  }

  function refreshSlides() {
    slides = Array.from(slider.querySelectorAll('.instagram-slide'));
    dots = Array.from(section.querySelectorAll('[data-instagram-dot]'));
  }

  function rebuildDots() {
    if (!dotsWrap || !dotTemplate) return;

    dotsWrap.innerHTML = '';
    slides.forEach((slide, index) => {
      const dot = dotTemplate.content.firstElementChild.cloneNode(true);
      dot.setAttribute('aria-label', `Show Instagram post ${index + 1}`);
      dot.dataset.instagramDot = String(index);
      if (index === 0) dot.classList.add('is-active');
      dotsWrap.appendChild(dot);
    });

    dotsWrap.classList.toggle('is-hidden', slides.length <= 1);
    refreshSlides();
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        scrollToIndex(Number(dot.dataset.instagramDot || 0));
      });
    });
  }

  function getStep() {
    const firstSlide = slides[0];
    if (!firstSlide) return slider.clientWidth;

    const slideStyles = window.getComputedStyle(slider);
    const gap = Number.parseFloat(slideStyles.columnGap || slideStyles.gap || 0);
    return firstSlide.getBoundingClientRect().width + gap;
  }

  function getActiveIndex() {
    const step = getStep();
    if (!step) return 0;
    return Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / step)));
  }

  function updateDots() {
    const activeIndex = getActiveIndex();
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  }

  function scrollToIndex(index) {
    const slide = slides[index];
    if (!slide) return;
    slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
  }

  if (prev) {
    prev.addEventListener('click', () => {
      scrollToIndex(getActiveIndex() - 1);
    });
  }

  if (next) {
    next.addEventListener('click', () => {
      scrollToIndex(getActiveIndex() + 1);
    });
  }

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      scrollToIndex(Number(dot.dataset.instagramDot || 0));
    });
  });

  slider.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateDots);
  }, { passive: true });

  if (feedUrl && window.fetch) {
    if (status) status.textContent = 'Loading latest Instagram posts...';

    window.requestAnimationFrame(async () => {
      try {
        const response = await fetch(feedUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Instagram feed request failed');

        const payload = await response.json();
        const items = normalizeItems(payload).slice(0, dynamicLimit);
        if (!items.length) throw new Error('Instagram feed returned no media');

        slider.innerHTML = '';
        items.forEach((item) => slider.appendChild(createSlide(item)));
        slider.scrollLeft = 0;
        refreshSlides();
        rebuildDots();
        updateDots();
        if (status) status.textContent = '';
      } catch (error) {
        if (status && slides.length === 0) {
          status.textContent = section.dataset.instagramEmptyText || 'Instagram feed is unavailable right now.';
        } else if (status) {
          status.textContent = '';
        }
      }
    });
  }

  updateDots();
}

document.querySelectorAll('[data-instagram-slider-section]').forEach(initInstagramSlider);

document.addEventListener('shopify:section:load', (event) => {
  if (event.target && event.target.matches('[data-instagram-slider-section]')) {
    initInstagramSlider(event.target);
  }
});
